import React, { useMemo } from 'react';
import { DataGrid, esES } from '@mui/x-data-grid';

const columns = [
  {
    field: 'CheckNum',
    width: 150,
    headerName: 'Nro Cheque',
    hideable: false,
    sortable: false,
  },
  {
    field: 'CheckSum',
    width: 200,
    headerName: 'Monto',
    hideable: false,
    sortable: false,
  },
  {
    field: 'DueDate',
    width: 200,
    headerName: 'Fecha vencimiento',
    hideable: false,
    sortable: false,
  },
  {
    field: 'BankCode',
    headerName: 'Banco',
    hideable: false,
    sortable: false,
  },
];

function ShowChecks(props) {
  const checks = props.checks;
  return (
    <DataGrid
      localeText={esES.components.MuiDataGrid.defaultProps.localeText}
      columns={columns}
      rows={checks}
      disableSelectionOnClick
    />
  );
}

export default ShowChecks;
